import { getStore } from '../store/store';
import { mutator } from 'satcheljs';
import { resetAccountsEditorStore } from '../actions/internalActions';
import { AccountsEditorState } from '../store/schema/AccountsEditorState';

mutator(resetAccountsEditorStore, () => {
    const store = getStore();

    store.accountPendingTrueTimeUpdate = null;
    store.trueTimeUpdateFailedAccount = null;
    store.accountsEditorState = getAccountsEditorState(store.accountsEditorState);
    store.selectedAccountProvider = null;
    store.source = null;
    store.accountCalendarsLoadStartTime = null;
    //owaSessionAddedAccountsTimestamps is scoped to OWA session so no reset
    store.editorSessionAddedAccounts = [];
    store.accountErrorReferralAccounts = [];
});

function getAccountsEditorState(accountsEditorState: AccountsEditorState) {
    return accountsEditorState == AccountsEditorState.AddFailedUnknown ||
        accountsEditorState == AccountsEditorState.AddFailedAadAuth ||
        accountsEditorState == AccountsEditorState.AddFailedUserCancelled ||
        accountsEditorState == AccountsEditorState.RemoveFailed ||
        accountsEditorState == AccountsEditorState.ReconnectFailed ||
        accountsEditorState == AccountsEditorState.TrueTimeDisabled
        ? AccountsEditorState.None
        : accountsEditorState;
}
